import {
  currentEnvironment as _currentEnvironment,
  currentProject as _currentProject,
} from '@gonfalon/bootstrap-data/bootstrapData';
import { Map } from '@gonfalon/immutable-shim/immutableShim';
import type { ImmutableServerError } from '@gonfalon/legacy-http-client/httpUtils';
import type { ImmutableMap } from '@gonfalon/legacy-immutable/immutableUtils';

import type { Project } from '#utils/projects/records/Project';
import { createProject } from '#utils/projects/records/Project';

export type ProjectEntities = Map<string, Project>;

export type ProjectsState = ImmutableMap<{
  lastFetched?: number;
  isFetching: boolean;
  entities: ProjectEntities;
  doNotFetch: boolean;
  error?: ImmutableServerError;
}>;

export function getProjectsInitialState(
  initialState: {
    currentProject: ReturnType<typeof _currentProject>;
    currentEnvironment: ReturnType<typeof _currentEnvironment>;
  } = { currentProject: _currentProject(), currentEnvironment: _currentEnvironment() },
) {
  const state: ProjectsState = Map({
    lastFetched: null,
    isFetching: false,
    entities: Map(),
    doNotFetch: false,
    error: null,
  });

  const currentProject = initialState.currentProject;
  const bootstrappedCurrentEnvironment = initialState.currentEnvironment;

  if (currentProject) {
    let p = createProject(
      // @ts-expect-error the project immutable record incorrectly assumes `environments` exists on the rep
      currentProject,
    );

    if (bootstrappedCurrentEnvironment) {
      p = p.update('environments', (envs) => envs.push(bootstrappedCurrentEnvironment._id));
    }

    return state.withMutations((st) =>
      st.merge({
        entities: Map({
          [p.key]: p,
        }),
      }),
    );
  }

  return state;
}
